import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { HintContainer, HintSkin } from '../Hint/styles';
import { Colors } from '../../common/Colors';
import { Variables } from '../../common/Variables';
import { viewType } from '.';

interface FieldContainerProps {
  isHintDefault?: boolean;
  isHintVisible?: boolean;
  view?: viewType;
}

// @ts-ignore
export const FieldContainer = styled('div')<FieldContainerProps>`
  position: relative;

  & + ${() => FieldContainer} {
    margin-top: ${props => (props.view === 'small' ? '1rem' : '2rem')};
  }

  ${props =>
    props.isHintVisible &&
    !props.isHintDefault &&
    css`
      ${HintContainer} {
        width: 28rem;
      }
    `};

  ${props =>
    props.isHintVisible &&
    props.isHintDefault &&
    css`
      ${FieldEmotion} {
        margin-bottom: -1px;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      }

      ${HintContainer} {
        z-index: 10;
      }

      ${HintSkin} {
        border-top-left-radius: 0;
        border-top-right-radius: 0;
      }
    `};
`;

type sizeListType = {
  [key: string]: string;
};

const sizeList: sizeListType = {
  small: '4rem',
  medium: '5rem',
  big: '6rem'
};

export interface FieldEmotionProps {
  autoHeight?: boolean;
  isDisabled?: boolean;
  sizeInput?: string;
}

export const FieldEmotion = styled('div')<FieldEmotionProps>`
  position: relative;
  display: flex;
  height: ${props => sizeList[props.sizeInput!]};
  font-size: 1.4rem;
  line-height: 1.2;
  background-clip: padding-box;
  border-radius: ${Variables.inputRadius};
  transition: border-color 0.2s, background-color 0.2s, color 0.2s;
  backface-visibility: hidden;

  ${props =>
    props.isDisabled
      ? css`
          cursor: not-allowed;
          color: ${Colors.text.disabled};
          background-color: ${Colors.ut.disabled} !important;
        `
      : css`
          cursor: text;
          color: ${Colors.text.defaultDim};
          background-color: ${Colors.ut.input};

          &:hover {
            background-color: ${Colors.ut.inputUp};
          }

          &:focus-within {
            z-index: 2;
            background-color: ${Colors.ut.inputDown};
          }
        `};

  ${props =>
    props.autoHeight &&
    css`
      ${Label} {
        align-items: flex-start;
        padding-top: 1.5rem;
        padding-bottom: 1.5rem;
      }
    `};
`;

interface LabelProps {
  size?: string;
  isShort?: boolean;
}

export const Label = styled('label')<LabelProps>`
  overflow: hidden;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  min-width: ${props => !props.isShort && '11rem'};
  max-width: 15rem;
  padding-left: 2rem;
  color: inherit;
  font-size: ${props => (props.size === 'big' ? '2.2rem' : 'inherit')};
  word-break: break-word;
  cursor: inherit;
  white-space: pre-line;
`;

export const field = css`
  flex-grow: 1;
  min-width: 0;
  padding: 0 1.9rem 0 0.9rem;
  margin: 1px; /* Отступ для красивого отображения автозаполнения в webkit браузерах */
  line-height: inherit;
  color: ${Colors.text.default};
  background-color: transparent;
  border: 0 !important;
  border-radius: inherit;
  box-shadow: inset 0 0 0 100px transparent;
  transition: color 0.2s, box-shadow 0.2s;
  cursor: inherit;

  &:first-child {
    padding-left: 2rem;
  }

  &:not(:last-child) {
    padding-right: 0;
  }

  &::placeholder {
    color: ${Colors.text.disabled};
    opacity: 1;
  }

  &:focus {
    outline: 0;
  }

  &:invalid,
  &:required {
    box-shadow: none;
    outline: 0;
  }

  &:disabled {
    color: ${Colors.text.disabled};
  }

  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    color: ${Colors.text.default};
    -webkit-text-fill-color: ${Colors.text.default};
    transition: background-color 0s 9999s;
    filter: none;
  }

  // Сбрасываем браузерный стиль инпута с типом number
  &[type='number'] {
    // Firefox
    appearance: textfield;

    // Chrome, Safari
    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      margin: 0;
      appearance: none;
    }
  }
`;

interface InputEmotionProps {
  sizeInput?: string;
}

export const InputEmotion = styled('input')<InputEmotionProps>`
  ${field};
  font-size: ${props => (props.sizeInput === 'big' ? '2.2rem' : 'inherit')};
`;

export const Caption = styled('div')`
  cursor: default;
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-shrink: 0;
  padding-right: 2rem;
  text-align: right;
  color: ${Colors.text.default};

  p {
    margin: 0;
  }
`;

export const Icon = styled('div')`
  user-select: none;
  position: relative;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 4.8rem;
  color: ${Colors.text.default};
`;
